import { useEffect } from 'react';
import { useLocation } from 'react-router';
export default function useWcpLogin(appStore) {
    const [showContent, setShowContent] = useState(false);
    const location = useLocation();
    useEffect(() => {
        const { search } = location;
        const params = new URLSearchParams(search);
        const isWcp = params.get('type') === 'wcp';
        const token = params.get('token');
        if (isWcp) {
            if (appStore.isLogIn) {
                setShowContent(true);
            } else if (token) {
                appStore.setLoginData({ token }, isWcp);
                setShowContent(true);
            } else {
                window.location.href = `/hdc-admin/sys/wc-authorize?targetUrl=${encodeURI(
                    window.location.href
                )}`;
            }
        } else {
            setShowContent(true);
        }
    }, []);

    return [showContent];
}
